import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '跑腿服务公司,同城快递帮帮跑腿急送1小时速达-365跑腿官网',
      content: {
        keywords: '365跑腿网|跑腿服务公司|同城快递|365跑腿|跑腿公司 同城代取代买代排队1小时速达-365跑腿官网',
        description: '365跑腿平均1分钟上门，1小时送达全城的同城快递及跑腿服务。同城代买代取代送代排队就找365跑腿服务公司，24小时提供安全、高效、便捷的高端专人专送服务!365跑腿APP下载,同城1小时速达'
      }
    }
  },
  {
    path: '/join',
    name: 'Join',
    component: () => import('../views/Join.vue'),
    meta: {
      title: '同城跑腿 APP|加盟哪个最好，365同城跑腿公司加盟优势，365跑腿网加盟支持，365跑腿平台加盟费用，365跑腿网加盟条件',
      content: {
        keywords: '同城跑腿 APP|加盟哪个最好，365同城跑腿公司加盟优势，365跑腿网加盟支持，365跑腿平台加盟费用，加盟条件',
        description: '跑腿公司加盟，365跑腿网一站式扶持，总部免费培训，零经验也可加盟365跑腿网最新招商加盟信息费用，电话流程加盟指导17669726577'
      }
    }
  },
  {
    path: '/riderHome',
    name: 'riderHome',
    component: () => import('../views/riderHome.vue'),
    meta: {
      title: '365跑腿骑士app下载，365骑士怎么样？',
      content: {
        keywords: '365骑士app安卓版-365骑士最新版下载365跑腿官网',
        description: '365骑士最新版是一款相当好用的生活服务软件,为用户提供各种跑腿代办服务,买菜,领快递,收东西等等有什么需要都可以上这里叫跑腿哦,闲暇之余想要兼职挣点外快,也可以...'
      }
    }
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('../views/news.vue'),
    meta: {
      title: '专业的跑腿公司_同城快送跑腿平均1小时_365跑腿网最新资讯',
      content: {
        keywords: '跑腿公司哪家好_同城快送跑腿平均1小时_365跑腿网最新资讯',
        description: '跑腿公司哪家好_365跑腿网口碑好的同城代买代取代送专业跑腿公司365跑腿网最新资讯。'
      }
    }
  },
  {
    path: '/page',
    name: 'page',
    component: () => import('../views/page.vue'),
    meta: {
      title: '头条详情'
    }
  },
  {
    path: '/brand',
    name: 'brand',
    component: () => import('../views/brand.vue'),
    meta: {
      title: '国内跑腿公司排名_365跑腿快送服务公司-APP秒接单秒响应_全城安心配_365跑腿网品牌实力',
      content: {
        keywords: '国内跑腿公司排名_365跑腿快送公司-APP秒接单秒响应_全城安心配送',
        description: '跑腿公司哪家好_365跑腿网口碑好的同城代买代取代送专业跑腿公司365跑腿网品牌实力'
      }
    }
  }
]

const router = new VueRouter({
  base: './',
  routes
})

export default router
